<template>
  <v-card>
    <v-card-title class="d-flex align-center">
      <v-icon class="mr-2">mdi-history</v-icon>
      Historique des conversations
    </v-card-title>
    <v-card-subtitle class="text-caption">
      <v-icon size="x-small" class="mr-1">mdi-information-outline</v-icon>
      Historique sauvegardé localement sur cet appareil (30 jours max)
    </v-card-subtitle>
    <v-card-subtitle v-if="conversations.length === 0" class="pa-4 text-center">
      Aucune conversation sauvegardée
    </v-card-subtitle>
    <v-list v-else density="compact">
      <v-list-item
        v-for="conv in conversations"
        :key="conv.id"
        :class="{ 'bg-primary-lighten': conv.id === currentConversationId }"
        @click="$emit('load-conversation', conv.id)"
        :disabled="conv.id === currentConversationId"
        style="cursor: pointer;"
      >
        <template v-slot:prepend>
          <v-icon>mdi-message-text-outline</v-icon>
        </template>
        <v-list-item-title class="text-body-2">{{ conv.title }}</v-list-item-title>
        <v-list-item-subtitle class="text-caption">
          {{ formatDate(conv.timestamp) }} • {{ conv.nb }} message(s)
        </v-list-item-subtitle>
        <template v-slot:append>
          <v-btn 
            icon 
            size="small" 
            variant="elevated" 
            @click.stop="confirmDelete(conv)"
            color="error"
            title="Supprimer cette conversation"
          >
            <v-icon size="small">mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-list-item>
    </v-list>
    
    <!-- Confirmation dialog -->
    <v-dialog v-model="deleteDialog" max-width="400">
      <v-card>
        <v-card-title class="text-h6">Confirmer la suppression</v-card-title>
        <v-card-text>
          Êtes-vous sûr de vouloir supprimer cette conversation ?
          <div class="mt-2 text-subtitle-2 font-weight-bold">{{ conversationToDelete?.title }}</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="deleteDialog = false">Annuler</v-btn>
          <v-btn color="error" @click="deleteConfirmed">Supprimer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
export default {
  name: "ConversationHistory",
  props: {
    conversations: {
      type: Array,
      default: () => []
    },
    currentConversationId: {
      type: String,
      default: null
    }
  },
  emits: ['load-conversation', 'delete-conversation'],
  data: () => ({
    deleteDialog: false,
    conversationToDelete: null
  }),
  methods: {
    formatDate(timestamp) {
      const date = new Date(timestamp);
      const now = new Date();
      const daysDiff = Math.floor((now - date) / (1000 * 60 * 60 * 24));
      
      if (daysDiff === 0) return "Aujourd'hui";
      if (daysDiff === 1) return "Hier";
      if (daysDiff < 7) return `Il y a ${daysDiff} jours`;
      if (daysDiff < 30) return `Il y a ${Math.floor(daysDiff / 7)} semaine(s)`;
      return date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' });
    },
    confirmDelete(conversation) {
      this.conversationToDelete = conversation;
      this.deleteDialog = true;
    },
    deleteConfirmed() {
      if (this.conversationToDelete) {
        this.$emit('delete-conversation', this.conversationToDelete.id);
        this.deleteDialog = false;
        this.conversationToDelete = null;
      }
    }
  }
};
</script>

<style scoped>
.bg-primary-lighten {
  background-color: rgba(var(--v-theme-primary), 0.1);
}
</style>
